export default {
  state: {
    local: ''
  },
  getters: {
  },
  mutations: {
    setLocal (state, lang) {
      state.local = lang;
    }
  }
};
